import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { api } from "../../../api/apiService";

const schema = yup.object().shape({
  password: yup.string().required("Password is required").min(6, "Password must be at least 6 characters"),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const ChangePassword = () => {
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const updatePassword = async (data) => {
    setIsLoading(true);

    try {
      const response = await api.post("change-password", {
        password: data.password,
        password_confirmation: data.password_confirmation,
      });

      toast.success(response.data.message, { dangerouslyHTMLString: true });
      reset();
    } catch (error) {
      const errorMessage = error?.data?.errors?.[0];
      toast.error(errorMessage || "An error occurred");
      console.log(error.data);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>Change Password</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/home">Home</Link>
            </li>
            <li className="breadcrumb-item">Change Password</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Update Password</h5>
                <form onSubmit={handleSubmit(updatePassword)}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        <input
                          type="password"
                          id="password"
                          className={`form-control ${errors.password ? "is-invalid" : ""}`}
                          {...register("password")}
                        />
                        {errors.password && (
                          <div className="invalid-feedback">
                            {errors.password.message}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="password_confirmation" className="form-label">
                          Confirm Password
                        </label>
                        <input
                          type="password"
                          id="password_confirmation"
                          className={`form-control ${errors.password_confirmation ? "is-invalid" : ""
                            }`}
                          {...register("password_confirmation")}
                        />
                        {errors.password_confirmation && (
                          <div className="invalid-feedback">
                            {errors.password_confirmation.message}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <button type="submit" disabled={isLoading} className="btn btn-primary">
                    Update Password
                    {isLoading && (
                      <span
                        className="spinner-border spinner-border-sm ms-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ChangePassword;
